<form autocomplete="off" [formGroup]="reasonForm" (submit)="onSubmit()" id="testedPartyForm" class="adj-form">
  <app-adjustement-modal-template title="Add {{ reasonType }} Reason" [showHeader]="0">
    <div body>
      <div class="col-lg-12 d-flex p-2">
        <span class="flex-grow-1 ey-float-label ey-textarea-label m-0 p-0" title="{{ reasonType }} Reason">
          <textarea
            class="form-control"
            id="reason"
            name="reason"
            maxlength="512"
            minRows="2"
            minHeight="48"
            paddingHeight="32"
            [disabled]="readOnly"
            appLabelFloat
            appAutosize
            formControlName="reason"
          ></textarea>
          <label for="reason">Reason</label>
        </span>
      </div>
    </div>
    <div footer>
      <button type="button" class="btn btn-default m-2" (click)="close()">Cancel</button>
      <button type="button" type="submit" class="btn btn-primary m-2" [disabled]="readOnly || !reasonForm.valid">
        {{ saveButtonText }}
      </button>
    </div>
  </app-adjustement-modal-template>
</form>
